/*
 * Exclusive accordions: opening one item closes the others.
 *
 *   <div data-accordion="details">            <details> items (product-faq)
 *   <div data-accordion="class"                class-toggled items (equipment-showcase)
 *        data-accordion-item=".x__item" data-accordion-trigger=".x__trigger">
 *     items get .is-open; triggers get aria-expanded.
 */
(function () {
  function initDetails(container) {
    container.addEventListener('click', function (e) {
      const clickedDetails = e.target.closest('details');
      if (!clickedDetails) return;
      container.querySelectorAll('details').forEach(function (details) {
        if (details !== clickedDetails && details.open) details.open = false;
      });
    });
  }

  function initClass(container) {
    const items = container.querySelectorAll(container.dataset.accordionItem);
    const triggers = container.querySelectorAll(container.dataset.accordionTrigger);
    triggers.forEach(function (trigger, index) {
      trigger.addEventListener('click', function () {
        const item = items[index];
        const isOpen = item.classList.contains('is-open');
        items.forEach(function (i) { i.classList.remove('is-open'); });
        triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
        if (!isOpen) {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function init(root) {
    root.querySelectorAll('[data-accordion]:not([data-accordion-ready])').forEach(function (container) {
      container.setAttribute('data-accordion-ready', '');
      if (container.dataset.accordion === 'details') initDetails(container);
      else initClass(container);
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
